import MainComponent from "./main_component";
import "../../css/master.css";
import Loader from '../../loader/loader';
import { useAtom, atom } from 'jotai';

const isLoadingAtom = atom(false);

function DWPLogin() {

    const [isLoading, setIsLoading] = useAtom(isLoadingAtom);

    const handleLoading = (set) => {

        setIsLoading(set)
    }

    return (
        <div>
            {isLoading === true ? <Loader /> : null}
            <MainComponent handleLoading={handleLoading} />
        </div>
    );

}


export default DWPLogin;